// First-party hostnames: the ones this deployment already serves under its
// own routing (RootRoute in src/App.tsx, isDemoHost, isEsportsHost,
// isEsportsDemoHost). Everything else is a candidate customer domain and gets
// routed to the public league hub resolver instead.
//
// Plain ESM, no Deno/Node-specific APIs, so the same module runs inside
// middleware.ts (Vercel Edge Middleware, repo root) and api/public-league.js.
// Re-exported to the app through src/config/customDomainHost.ts, mirroring how
// api/_publicLeagueSeo.js is re-exported through src/utils/publicLeagueSeo.ts.
//
// Deliberately prefix-based, mirroring isDemoHost/isEsportsHost/
// isEsportsDemoHost rather than an exact-match allowlist, so demo.localhost
// and esports.localhost keep working in local dev the same way those helpers
// already do.

/**
 * True when `hostname` (optionally carrying a port, e.g. "demo.localhost:8080")
 * is one of StatHarbour's own hosts.
 */
export function isFirstPartyHost(hostname) {
  const host = (hostname || "").split(":")[0].toLowerCase();
  if (!host) return true;
  if (host === "statharbour.com" || host === "www.statharbour.com") return true;
  // Covers demo.statharbour.com AND demo.esports.statharbour.com (which starts
  // with "demo." too), plus demo.localhost for local dev.
  if (host.startsWith("demo.")) return true;
  // Covers esports.statharbour.com and esports.localhost.
  if (host.startsWith("esports.")) return true;
  if (host.endsWith(".vercel.app")) return true;
  if (host === "localhost" || host.endsWith(".localhost")) return true;
  return false;
}
